import { storyblokEditable, renderRichText } from '@storyblok/react'
import Image from 'next/image'
import { getStoryblokImageDimensions, hasRichTextContent } from '@/lib/utils'
import { ImageTextStoryblok } from '@/component-types-sb'

export default function ImageText({ blok }: { blok: ImageTextStoryblok }) {
    const isImageLeft = blok.imagePosition !== 'right'
    const imageDimensions = getStoryblokImageDimensions(blok.image?.filename || '')
    const imageWidth = blok.image?.width || imageDimensions?.width || 1200
    const imageHeight = blok.image?.height || imageDimensions?.height || 800
    const imageSrc = blok.image?.filename || ''
    const imageTextHtml = blok.imageText
        ? String(renderRichText(blok.imageText as Parameters<typeof renderRichText>[0]) || '')
        : ''
    const hasText = hasRichTextContent(imageTextHtml)
    const textHtml = String(renderRichText(blok.text as Parameters<typeof renderRichText>[0]) || '')

    return (
        <section {...storyblokEditable(blok)} className="bg-background max-w-[1200px] mx-auto p-5 md:p-10">
            {blok.heading && <h2 id={blok.heading}>{blok.heading}</h2>}
            <div className="mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
                {isImageLeft && (
                    <div className="flex flex-col">
                        {imageSrc && (
                            <Image
                                src={imageSrc}
                                alt={blok.image?.alt || ''}
                                width={imageWidth}
                                height={imageHeight}
                                sizes="(max-width: 854px) calc(100vw - 50px), 550px"
                                className="w-full h-auto"
                                loading="eager"
                            />
                        )}
                        {hasText && (
                            <div className="prose text-sm p-2 md:max-w-[85%] mx-auto bg-white [&>*:last-child]:mb-0"
                            dangerouslySetInnerHTML={{ __html: imageTextHtml }} />
                        )}
                    </div>
                )}

                <div
                    className="prose"
                    dangerouslySetInnerHTML={{ __html: textHtml }}
                />

                {!isImageLeft && (
                    <div className="flex flex-col">
                        {imageSrc && (
                            <Image
                                src={imageSrc}
                                alt={blok.image?.alt || ''}
                                width={imageWidth}
                                height={imageHeight}
                                sizes="(max-width: 854px) calc(100vw - 50px), 550px"
                                className="w-full h-auto"
                                loading="eager"
                            />
                        )}
                        {hasText && (
                            <div className="prose text-sm p-2 md:max-w-[85%] mx-auto bg-white [&>*:last-child]:mb-0"
                            dangerouslySetInnerHTML={{ __html: imageTextHtml }} />
                        )}
                    </div>
                )}

            </div>
        </section>
    )
}